import logo from './logo.svg';
import './App.css';
import AppRouter from "./AppRouter";
import {UserProvider} from "./Context/UserContext";
import {ProjectProvider} from "./Context/ProjectContext";
import {ModalProvider} from "./Context/ModalContext";
import Modal from "./Components/Modal";

function App() {
  return (
    <div className="App">
        <ModalProvider>
            <Modal />
            <UserProvider>
                <ProjectProvider>
                    <AppRouter />
                </ProjectProvider>
            </UserProvider>
        </ModalProvider>
    </div>
  );
}

export default App;
